import React from 'react';
import { product, waitingLines } from '../../data/product';
export function IdentificationSection() {
  return <section aria-labelledby="identificacion-titulo" className="w-full border-t border-sand bg-ivory" data-id="element-112" data-mp="ur7449ypawyp">
      <div className="mx-auto grid max-w-6xl gap-12 px-6 py-24 lg:grid-cols-12 lg:items-center lg:gap-12 lg:px-10 lg:py-36" data-id="element-113" data-mp="18ilpgng2za8x">
        <img src={product.identificationImage} alt="Mujer junto a una ventana con luz de tarde, sosteniendo un cuaderno cerrado" className="aspect-[4/5] w-full rounded-sm object-cover lg:col-span-5" data-id="element-114" data-mp="13lbyv4gygsji" />
        <div className="lg:col-span-6 lg:col-start-7" data-id="element-115" data-mp="psvv21g8cqhj">
          <h2 id="identificacion-titulo" className="font-serif text-[2rem] font-normal leading-[1.12] tracking-tight text-carbon sm:text-4xl lg:text-[2.75rem]" data-id="element-116" data-mp="pugn9kf2nxc8">
            El miedo al qué dirán puede costarte la vida que deseas vivir.
          </h2>
          <ul className="mt-10 space-y-3 border-l-2 border-gold pl-6" data-id="element-117" data-mp="1w8g0r0kr4qr2">
            {waitingLines.map(line => <li key={line} className="text-lg text-stone" data-id="element-118" data-mp="5uad6wzcuvx9">
                {line}
              </li>)}
          </ul>
          <p className="mt-10 font-serif text-2xl italic leading-snug text-carbon" data-id="element-119" data-mp="fsq00nrcnj0y">
            Y mientras tanto, nuestros sueños siguen esperando.
          </p>
        </div>
      </div>
    </section>;
}